export const categories = [
  {
    slug: 'self-portrait-composition',
    name: '自拍构图',
    description: '掌握自拍构图的核心法则，从三分法到引导线，让你的自拍作品更具艺术感与专业度。',
    icon: 'ri-camera-lens-line',
    color: 'accent',
    articleCount: 12,
  },
  {
    slug: 'candid-capture',
    name: '偷拍抓拍',
    description: '街头抓拍与隐蔽拍摄技巧全解析，教你如何在自然状态下捕捉最真实的人物瞬间。',
    icon: 'ri-eye-2-line',
    color: 'primary',
    articleCount: 15,
  },
  {
    slug: 'equipment-guide',
    name: '设备推荐',
    description: '从手机到单反，从入门到专业，为你推荐最适合自拍与抓拍的摄影器材。',
    icon: 'ri-smartphone-line',
    color: 'secondary',
    articleCount: 8,
  },
  {
    slug: 'angle-selection',
    name: '角度选择',
    description: '不同角度的视觉效果解析，教你如何利用拍摄角度修饰脸型、突出气质。',
    icon: 'ri-focus-3-line',
    color: 'accent',
    articleCount: 10,
  },
  {
    slug: 'post-processing',
    name: '后期处理',
    description: '从调色到磨皮，手把手教你用手机和电脑软件完成专业级人像后期处理。',
    icon: 'ri-image-edit-line',
    color: 'primary',
    articleCount: 9,
  },
  {
    slug: 'documentary',
    name: '人文纪实',
    description: '用镜头记录生活百态，人文纪实摄影的观察方法与叙事技巧。',
    icon: 'ri-landscape-line',
    color: 'secondary',
    articleCount: 7,
  },
];

export const articles = [
  {
    id: 1,
    slug: 'golden-ratio-self-portrait',
    title: '黄金分割自拍法：3分钟学会专业级构图',
    excerpt: '黄金分割是摄影构图的基石。本文将详细解析如何将黄金分割法则应用到自拍中，让你的人像作品瞬间提升档次。从手机前置摄像头到单反，全面适配各类设备。',
    category: 'self-portrait-composition',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Artistic%20self-portrait%20photography%20composition%20with%20golden%20ratio%20grid%20overlay%2C%20warm%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20soft%20cream%20and%20beige%20background%2C%20elegant%20editorial%20style%2C%20high%20detail%20portrait%20with%20geometric%20composition%20lines&width=800&height=450&seq=article-cover-01&orientation=landscape',
    readTime: 8,
    date: '2026-08-10',
    author: '摄影师小林',
    tags: ['黄金分割', '自拍构图', '摄影基础'],
    content: [
      {
        type: 'h2',
        text: '什么是黄金分割构图',
      },
      {
        type: 'p',
        text: '黄金分割（Golden Ratio）是数学中的经典比例，约为1:1.618。在摄影中，将画面按此比例分割，把主体放在分割线或交点处，能创造出视觉上最舒适、最自然的构图效果。这一法则被广泛应用于绘画、建筑和摄影等多个艺术领域，是每一位摄影爱好者必须掌握的基础知识。',
      },
      {
        type: 'p',
        text: '在自拍场景中，黄金分割可以帮助你快速确定面部、眼睛等关键元素在画面中的最佳位置。相比死板的正中央构图，黄金分割构图能让照片显得更加生动、有层次感，同时保留人物的主体地位。',
      },
      {
        type: 'h3',
        text: '黄金分割与三分法的区别',
      },
      {
        type: 'p',
        text: '很多人容易把黄金分割和三分法混淆。三分法是将画面分成三等份，而黄金分割的比例约为0.618:0.382。实际应用中，三分法可以看作是黄金分割的简化版。对于自拍来说，三分法更容易操作——将眼睛放在上方三分线上，就能快速获得自然舒适的构图。',
      },
      {
        type: 'h2',
        text: '手机自拍中的黄金分割实操',
      },
      {
        type: 'p',
        text: '现在的智能手机大多内置了网格线功能，打开相机设置中的"网格"选项即可。将网格线与黄金分割点结合使用，可以有效提升自拍质量。以下是具体操作步骤：',
      },
      {
        type: 'h3',
        text: '步骤一：开启网格辅助线',
      },
      {
        type: 'p',
        text: '进入手机相机设置，找到"网格"或"参考线"选项，将其开启。iPhone用户可以在"设置 - 相机"中找到；安卓用户通常在相机应用的设置菜单内。开启后取景框中会出现九宫格线条。',
      },
      {
        type: 'h3',
        text: '步骤二：确定视觉重心',
      },
      {
        type: 'p',
        text: '自拍时，眼睛是绝对的视觉重心。将你的眼睛（或双眼连线）对准九宫格上方三分线的交叉点附近，这样画面看起来就会非常自然。如果你想要更强烈的艺术效果，可以尝试将一只眼睛精确对准分割点。',
      },
      {
        type: 'h3',
        text: '步骤三：留白与呼吸感',
      },
      {
        type: 'p',
        text: '在人物视线方向留出足够的空间（称为"视线空间"或"呼吸空间"），这是黄金分割构图的重要延伸。如果看向右侧，就在右侧多留白；如果看向左侧，同理。这样照片就不会显得压抑。',
      },
      {
        type: 'h2',
        text: '单反/微单自拍的高级技巧',
      },
      {
        type: 'p',
        text: '使用单反或微单自拍时，由于没有前置屏幕预览，构图难度会有所提升。建议使用翻转屏功能或外接监视器，同时结合三脚架来保证画面稳定。以下是一些进阶建议：',
      },
      {
        type: 'p',
        text: '首先，在架设相机时先用参照物定位。可以在黄金分割点位置放一个标志物，然后站在标志物后方进行拍摄。其次，使用相机的Wi-Fi遥控功能，通过手机实时查看画面构图。最后，拍摄时使用连拍模式，从多张照片中选择构图最精准的一张。',
      },
      {
        type: 'h2',
        text: '常见错误与改进方法',
      },
      {
        type: 'p',
        text: '错误一：头顶留白过多。很多自拍新手习惯将头部放在画面正中央，导致头顶有大量空白区域。改进方法：将眼睛位置对齐上方三分线，让面部占据画面约60%-70%的比例。',
      },
      {
        type: 'p',
        text: '错误二：忽视背景元素。黄金分割不仅适用于人物位置，背景中的线条、建筑、自然元素也可以作为构图的一部分。尝试将地平线、墙线等元素放在分割线上，与人物形成呼应。',
      },
      {
        type: 'p',
        text: '错误三：过度依赖后期裁剪。虽然可以通过后期裁剪来调整构图，但这会损失画质。尽量在拍摄时就确定好构图，后期只做微调。',
      },
      {
        type: 'h2',
        text: '总结',
      },
      {
        type: 'p',
        text: '黄金分割构图法是自拍进阶的必修课。从手机前置摄像头到专业相机，这一法则都能帮助你拍出更加和谐、自然的人像作品。关键是多多练习，将黄金分割内化为你的视觉直觉。当你不再需要刻意去想"该放在哪里"时，你就真正掌握了这项技巧。',
      },
    ],
    faq: [
      { q: '黄金分割和三分法是一回事吗？', a: '不完全一样。三分法是黄金分割的简化版，将画面三等分。黄金分割的比例更精确（约1:1.618），实际拍摄中用三分法即可达到很好的效果。' },
      { q: '手机自拍如何快速使用黄金分割？', a: '开启手机相机的网格线功能，将眼睛放在上方三分线的交叉点附近，视线方向多留白即可。' },
      { q: '黄金分割构图适合所有人吗？', a: '黄金分割是一种被广泛验证的视觉舒适比例，适合绝大多数场景。但创意摄影中有时刻意打破规则也能产生惊艳效果。' },
    ],
    relatedArticleIds: [2, 5, 3],
  },
  {
    id: 2,
    slug: 'street-candid-beginner',
    title: '街头抓拍入门：从害羞到自信的12个实战技巧',
    excerpt: '街头抓拍是人文摄影的核心技能。本文分享12个实用技巧，帮助初学者克服心理障碍，在公共场合自信地进行抓拍创作，捕捉城市生活的真实瞬间。',
    category: 'candid-capture',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Candid%20street%20photography%20in%20urban%20setting%2C%20natural%20moment%20captured%2C%20warm%20afternoon%20light%2C%20pedestrians%20walking%20in%20city%2C%20soft%20cream%20tone%20background%2C%20editorial%20photography%20style%2C%20artistic%20composition%2C%20minimalist%20aesthetic&width=800&height=450&seq=article-cover-02&orientation=landscape',
    readTime: 12,
    date: '2026-08-08',
    author: '街拍达人阿杰',
    tags: ['街头摄影', '抓拍技巧', '新手入门'],
    content: [
      {
        type: 'h2',
        text: '为什么要学习街头抓拍',
      },
      {
        type: 'p',
        text: '街头抓拍（Street Candid）是人文纪实摄影中最富魅力的门类之一。它不需要精致的布光，不需要专业模特，只需要你带着相机走上街头，用敏锐的观察力捕捉那些稍纵即逝的真实瞬间。这些照片往往比摆拍更加生动、更有故事感。',
      },
      {
        type: 'p',
        text: '然而对于许多初学者来说，最大的障碍不是技术，而是心理——害羞、害怕被拒绝、担心侵犯他人隐私。本文将分享12个经过验证的实战技巧，帮助你从零开始，一步步成为自信的街头摄影师。',
      },
      {
        type: 'h2',
        text: '心理建设篇：克服拍摄恐惧',
      },
      {
        type: 'h3',
        text: '技巧一：从无人场景开始',
      },
      {
        type: 'p',
        text: '不要一开始就对着陌生人拍。先从街景、建筑、光影等无人场景练手，熟悉相机的操作和构图感觉。当你对设备操作足够熟练后，再逐渐将人物纳入画面。这是一个循序渐进的过程，不需要急于求成。',
      },
      {
        type: 'h3',
        text: '技巧二：学会"隐形"',
      },
      {
        type: 'p',
        text: '街头摄影师需要培养一种"融入环境"的能力。穿着低调、动作自然、不要长时间盯着被摄者看。建议穿着中性色调的衣服，避免过于鲜艳的颜色引起注意。使用小型相机或手机而非大型单反，也能大幅降低存在感。',
      },
      {
        type: 'h3',
        text: '技巧三：预对焦与盲拍',
      },
      {
        type: 'p',
        text: '预对焦是指提前将焦点设置在预估距离上，然后在不看取景器的情况下按下快门。这种"盲拍"方式让你可以自然地拿着相机经过拍摄对象，对方甚至不会意识到你按下了快门。使用广角镜头和小光圈可以增加景深范围，提高成功率。',
      },
      {
        type: 'h2',
        text: '技术实战篇：提升出片率',
      },
      {
        type: 'h3',
        text: '技巧四：善用连拍模式',
      },
      {
        type: 'p',
        text: '连拍是街头抓拍的好帮手。设定连拍模式后，在一次经过中连续拍摄多张，之后从中选择表情、姿态最自然的一张。对于动态场景，连拍能帮你捕捉到"决定性瞬间"——那个最完美的刹那。',
      },
      {
        type: 'h3',
        text: '技巧五：利用环境反射',
      },
      {
        type: 'p',
        text: '商店橱窗、汽车后视镜、水面倒影——这些都是街头摄影的绝佳道具。通过反射拍摄，你可以在不直视拍摄对象的情况下完成构图，既能保护自己不被发现，又能创造出独特的视觉效果。',
      },
      {
        type: 'h3',
        text: '技巧六：等待而非追逐',
      },
      {
        type: 'p',
        text: '与其追着有趣的画面跑，不如找到一个好的背景或光影位置，然后耐心等待合适的人物走入画面。这种"守株待兔"的方法成功率更高，构图也更可控。',
      },
      {
        type: 'h2',
        text: '进阶心法：从拍摄到创作',
      },
      {
        type: 'h3',
        text: '技巧七：寻找故事性',
      },
      {
        type: 'p',
        text: '一张好的街头照片不只是"记录"，更应该是"讲述"。寻找人物与环境之间的互动、对比、冲突或和谐。两个人擦肩而过的瞬间、老人与小孩的同框、现代化的广告牌与传统摊贩的并置——这些都能赋予照片更深层的叙事意味。',
      },
      {
        type: 'h2',
        text: '总结',
      },
      {
        type: 'p',
        text: '街头抓拍是一门需要勇气和耐心的艺术。记住这12个技巧，从今天开始带上你的手机或相机，走上街头去练习。前100张可能都不理想，但第101张也许就是你想要的"决定性瞬间"。摄影的精髓在于观察和感受，技术只是辅助工具。',
      },
    ],
    faq: [
      { q: '街头抓拍需要征得对方同意吗？', a: '在公共场合拍摄一般不违法，但建议尊重他人意愿。如果对方明确表示不愿意被拍，应立即删除照片。用于商业用途时则必须获得肖像权授权。' },
      { q: '初学者用什么设备最好？', a: '推荐从手机开始。现代旗舰手机的成像质量已经非常出色，而且最为隐蔽。进阶后可考虑小型微单或卡片机，体积越小越适合街头抓拍。' },
      { q: '如何在暗光环境下抓拍？', a: '提高ISO、使用大光圈镜头、寻找有光源的位置。如果使用手机，可以开启夜景模式。暗光下的照片有独特的氛围感，颗粒感反而是一种风格。' },
    ],
    relatedArticleIds: [1, 4, 6],
  },
  {
    id: 3,
    slug: 'mobile-selfie-gear-2026',
    title: '2026年手机自拍配件推荐：从补光灯到稳定器',
    excerpt: '想要提升手机自拍质量？除了技术，合适的配件同样重要。本文盘点2026年最值得入手的手机自拍配件，从环形补光灯到三轴稳定器，帮你做出明智选择。',
    category: 'equipment-guide',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Smartphone%20photography%20accessories%20flat%20lay%2C%20ring%20light%20and%20gimbal%20stabilizer%2C%20clean%20minimalist%20product%20photography%2C%20soft%20cream%20background%2C%20warm%20lighting%2C%20editorial%20style%2C%20high%20detail&width=800&height=450&seq=article-cover-03&orientation=landscape',
    readTime: 10,
    date: '2026-08-05',
    author: '数码评测师老张',
    tags: ['手机摄影', '摄影配件', '设备推荐'],
    content: [
      {
        type: 'h2',
        text: '为什么需要手机自拍配件',
      },
      {
        type: 'p',
        text: '现代手机的影像能力已经非常强大，但在自拍场景下仍然存在一些先天不足：前置摄像头画质相对后置较逊、手持拍摄稳定性不足、暗光环境噪点明显。合适的配件可以有效弥补这些短板，让你的手机自拍质量大幅提升。',
      },
      {
        type: 'h2',
        text: '补光设备推荐',
      },
      {
        type: 'h3',
        text: '环形补光灯',
      },
      {
        type: 'p',
        text: '环形补光灯是目前最主流的自拍补光设备。它能提供均匀柔和的面部照明，消除阴影，还能在眼睛里形成漂亮的环形眼神光。推荐选择色温可调（3000K-6000K）和亮度可调的产品，适应不同场景需求。预算在100-300元之间即可买到品质不错的款式。',
      },
      {
        type: 'h3',
        text: '便携式LED面板灯',
      },
      {
        type: 'p',
        text: '如果你需要更强的补光效果，便携式LED面板灯是更好的选择。它们通常亮度更高、照射范围更广，适合户外或光线极差的环境。部分产品还支持RGB色彩调节，能为创意拍摄提供更多可能性。',
      },
      {
        type: 'h2',
        text: '稳定设备推荐',
      },
      {
        type: 'h3',
        text: '三轴手机稳定器',
      },
      {
        type: 'p',
        text: '对于视频自拍和Vlog创作者来说，三轴稳定器是必备神器。它能消除手持拍摄的抖动，让画面流畅稳定。2026年的主流产品重量已降至300克以内，折叠后可以轻松放入口袋。推荐关注大疆和智云等品牌，入门款价格在500-800元。',
      },
      {
        type: 'h3',
        text: '桌面三脚架 + 蓝牙遥控器',
      },
      {
        type: 'p',
        text: '如果你主要拍摄静态自拍，桌面三脚架加蓝牙遥控器的组合性价比最高。可以解放双手进行各种姿势的拍摄，蓝牙遥控器让你无需触屏就能触发快门。推荐选择带球形云台的款式，方便调整拍摄角度。',
      },
      {
        type: 'h2',
        text: '镜头配件推荐',
      },
      {
        type: 'h3',
        text: '外接广角镜头',
      },
      {
        type: 'p',
        text: '外接广角镜头可以扩展手机前置摄像头的视野，让自拍时能容纳更多背景或多人合影。不过需要注意的是，低价广角镜头往往边缘画质下降明显，建议选择知名品牌的产品。',
      },
      {
        type: 'h2',
        text: '总结与购买建议',
      },
      {
        type: 'p',
        text: '对于大多数用户，环形补光灯+桌面三脚架+蓝牙遥控器的组合是最实用的选择，总预算控制在300元以内即可。如果你有视频创作需求，再考虑添加三轴稳定器。记住：配件是锦上添花，核心还是你的拍摄技术和审美。',
      },
    ],
    faq: [
      { q: '环形补光灯有必要买贵的吗？', a: '100-300元价位的环形灯已经能满足日常需求。更贵的产品主要在材质做工和最高亮度上有区别，普通用户不需要追求高端款。' },
      { q: '手机稳定器值得买吗？', a: '如果你经常用手机拍视频或直播，非常值得。如果只是偶尔自拍，桌面三脚架就足够了。' },
      { q: '外接镜头会影响画质吗？', a: '低价外接镜头确实会降低画质，尤其是边缘部分。建议要么不买，要么选择知名品牌的中高端产品。' },
    ],
    relatedArticleIds: [1, 4, 5],
  },
  {
    id: 4,
    slug: 'face-angle-photography',
    title: '脸型与拍摄角度：找到最适合你的自拍角度',
    excerpt: '圆脸、方脸、长脸……不同脸型需要不同的拍摄角度来修饰。本文详解6种脸型的最佳自拍角度，配合实例图片，让你找到最上镜的拍摄方式。',
    category: 'angle-selection',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Portrait%20photography%20angle%20study%2C%20woman%20face%20from%20different%20angles%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20studio%20background%2C%20cream%20and%20beige%20tones%2C%20editorial%20beauty%20photography%2C%20professional%20lighting%20setup&width=800&height=450&seq=article-cover-04&orientation=landscape',
    readTime: 9,
    date: '2026-08-03',
    author: '人像摄影师小美',
    tags: ['拍摄角度', '人像摄影', '自拍技巧'],
    content: [
      {
        type: 'h2',
        text: '为什么拍摄角度如此重要',
      },
      {
        type: 'p',
        text: '同样的一个人，从不同角度拍摄会呈现出截然不同的视觉效果。合适的角度可以修饰脸型、突出优点、隐藏不足；而错误的角度则可能让本来好看的人显得不那么上镜。掌握拍摄角度的规律，是自拍进阶的关键一步。',
      },
      {
        type: 'h2',
        text: '六种常见脸型的最佳角度',
      },
      {
        type: 'h3',
        text: '圆脸：高角度俯拍 + 侧脸',
      },
      {
        type: 'p',
        text: '圆脸的特点是面部轮廓柔和、脸颊饱满。最佳拍摄策略是从略高于眼睛的角度俯拍（约20-30度），同时将面部微微转向一侧。这样可以拉长面部线条，减少圆润感。避免从下方仰拍，那会让脸显得更圆更宽。',
      },
      {
        type: 'h3',
        text: '方脸：45度侧脸 + 柔和光线',
      },
      {
        type: 'p',
        text: '方脸的下颌线条较为明显。建议使用45度侧脸角度，让下颌线形成柔和的斜线而非直线。同时利用柔和的侧光来弱化棱角感，创造更温和的视觉效果。避免正面直拍和硬光源。',
      },
      {
        type: 'h3',
        text: '长脸：正面 + 略微低头',
      },
      {
        type: 'p',
        text: '长脸型需要让脸部在视觉上显得更宽一些。正面拍摄，下巴微微向下收（低头约10-15度），可以让面部看起来更平衡。同时可以通过刘海或发型在视觉上压缩面部长度。',
      },
      {
        type: 'h3',
        text: '心形脸：正面微侧 + 平视角度',
      },
      {
        type: 'p',
        text: '心形脸额头较宽、下巴较尖。最佳角度是正面微微偏向一侧，相机与眼睛平齐。这样可以平衡额头和下巴的比例。避免过高的俯拍角度，那会让额头显得更宽。',
      },
      {
        type: 'h3',
        text: '菱形脸：3/4侧脸角度',
      },
      {
        type: 'p',
        text: '菱形脸颧骨突出、额头和下巴较窄。3/4侧脸角度（即面部转向约60度）可以柔化颧骨的突出感，让面部线条更加流畅。搭配柔和的正面补光效果更佳。',
      },
      {
        type: 'h3',
        text: '椭圆脸：几乎适合所有角度',
      },
      {
        type: 'p',
        text: '椭圆脸被称为"标准脸型"，几乎适合所有拍摄角度。建议多尝试不同角度来创造多样化的视觉效果。正面、侧脸、俯拍、仰拍都可以大胆尝试，找到最能表达当下情绪的那个角度。',
      },
      {
        type: 'h2',
        text: '通用自拍角度法则',
      },
      {
        type: 'p',
        text: '无论什么脸型，有几个通用法则值得牢记：第一，相机略高于眼睛是最安全的角度，能有效避免双下巴和鼻孔特写；第二，微微侧脸通常比完全正面更显瘦；第三，拍摄时注意脖子和肩膀的线条，挺直的上半身能让整个人更有气质。',
      },
      {
        type: 'h2',
        text: '实战练习建议',
      },
      {
        type: 'p',
        text: '用手机在同一光线条件下，尝试从10个不同角度拍摄自己：正面上方、正面平视、正面下方、左侧45度上中下、右侧45度上中下。然后对比这些照片，找出最适合你的2-3个角度，以后自拍时优先使用这些角度。',
      },
    ],
    faq: [
      { q: '如何快速判断自己的脸型？', a: '将头发全部梳起，正对镜子拍一张照片，观察额头、颧骨、下颌的宽度比例。额头最宽为心形，颧骨最宽为菱形，三者宽度相近为方脸或圆脸。' },
      { q: '自拍时手机举多高最合适？', a: '一般建议高于眼睛15-30厘米，手机微微向下倾斜。这样既能避免变形，又能制造自然的显瘦效果。' },
    ],
    relatedArticleIds: [1, 5, 3],
  },
  {
    id: 5,
    slug: 'lightroom-mobile-portrait',
    title: '手机版Lightroom人像调色全攻略：从入门到出片',
    excerpt: '不需要电脑，只用手机版Lightroom就能完成专业级人像调色。本文详细讲解肤色处理、色调调整、预设使用等核心技巧，附带5个免费预设配方。',
    category: 'post-processing',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Mobile%20photo%20editing%20app%20interface%20on%20smartphone%2C%20before%20and%20after%20portrait%20comparison%2C%20Lightroom%20mobile%20app%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20cream%20background%2C%20editorial%20style%2C%20warm%20lighting&width=800&height=450&seq=article-cover-05&orientation=landscape',
    readTime: 15,
    date: '2026-08-01',
    author: '后期达人阿光',
    tags: ['Lightroom', '后期调色', '手机修图'],
    content: [
      {
        type: 'h2',
        text: '为什么要用Lightroom手机版',
      },
      {
        type: 'p',
        text: 'Adobe Lightroom手机版是目前功能最强大的移动端修图软件。与美图秀秀等一键美化工具不同，Lightroom提供了专业级的色彩管理、曲线调节和细节处理功能。对于追求高质量人像作品的摄影爱好者来说，它是手机后期处理的首选工具。',
      },
      {
        type: 'h2',
        text: '基础调整：为后续调色打好底子',
      },
      {
        type: 'h3',
        text: '曝光与对比度',
      },
      {
        type: 'p',
        text: '人像照片的曝光以面部肤色为参考标准。将曝光度调整到肤色看起来自然明亮的程度，而不是以背景为准。对比度建议控制在+10到+25之间，过高的对比度会让面部阴影过重，显得皮肤状态不佳。',
      },
      {
        type: 'h3',
        text: '高光与阴影',
      },
      {
        type: 'p',
        text: '人像后期的一个重要原则是"压低高光、提亮阴影"，目的是保留更多细节。将高光降低20-40，阴影提升15-30，这样既保留了天空或亮部区域的细节，又不会让暗部一片死黑。',
      },
      {
        type: 'h2',
        text: '肤色处理：人像后期的核心',
      },
      {
        type: 'h3',
        text: '使用颜色混合器精准调肤',
      },
      {
        type: 'p',
        text: '进入"颜色混合"面板，找到橙色滑块——这是控制肤色的关键通道。降低橙色饱和度可以让皮肤看起来更白皙通透；提高橙色明度可以让肤色更明亮。对于亚洲肤色，建议橙色饱和度-5到-15，明度+5到+15。',
      },
      {
        type: 'h3',
        text: 'HSL精细调节',
      },
      {
        type: 'p',
        text: '除了橙色，红色和黄色也会影响肤色表现。红色控制嘴唇和脸颊的红润度，黄色影响皮肤的整体色调。建议红色饱和度+5到+10让嘴唇更有血色，黄色饱和度-5到-10去除皮肤的黄气。',
      },
      {
        type: 'h2',
        text: '5个免费预设配方',
      },
      {
        type: 'h3',
        text: '预设一：日系清新风',
      },
      {
        type: 'p',
        text: '曝光+0.3、对比度-10、高光-30、阴影+25、白色色阶-10、黑色色阶+15；色温偏冷-5、色调偏绿+3；自然饱和度+15；橙色饱和度-10、橙色明度+15；绿色饱和度-15、绿色明度+10。整体效果清新自然，肤色白皙通透。',
      },
      {
        type: 'h3',
        text: '预设二：暖调电影感',
      },
      {
        type: 'p',
        text: '曝光+0.1、对比度+20、高光-40、阴影+20；色温+10、色调+0；自然饱和度-5；纹理+10、清晰度-5；橙色饱和度+5、橙色明度+10；加入暗角-15。效果温暖柔和，适合傍晚或室内暖光环境。',
      },
      {
        type: 'h3',
        text: '预设三：高级灰调',
      },
      {
        type: 'p',
        text: '曝光+0.2、对比度-15、高光-50、阴影+30；自然饱和度-20；色调曲线：拉出S形但整体上移；橙色饱和度-15、橙色明度+20。效果低调高级，适合街拍和时尚风格。',
      },
      {
        type: 'h3',
        text: '预设四：复古胶片',
      },
      {
        type: 'p',
        text: '曝光-0.1、对比度+25、高光-30、阴影+10；色温+15、色调+5；自然饱和度+10；纹理+20；添加颗粒+15；橙色饱和度+5。效果有质感的复古胶片味道，适合人文纪实类照片。',
      },
      {
        type: 'h3',
        text: '预设五：冷白皮人像',
      },
      {
        type: 'p',
        text: '曝光+0.5、对比度-5、高光-20、阴影+15；色温-10、色调+0；自然饱和度+10；橙色饱和度-20、橙色明度+25、橙色色相+5；红色饱和度+10。效果肤色冷白通透，适合女生自拍。',
      },
      {
        type: 'h2',
        text: '总结',
      },
      {
        type: 'p',
        text: '手机版Lightroom的人像调色并不复杂，关键是理解每个参数的作用，并根据照片的实际情况灵活调整。以上预设配方是很好的起点，但不要生搬硬套——每张照片的光线、色彩都不同，学会观察和分析，才能真正掌握后期处理的精髓。',
      },
    ],
    faq: [
      { q: 'Lightroom手机版免费吗？', a: '基础功能免费，但高级功能（如修复画笔、选择性调整）需要付费订阅。对于大多数用户，免费版已经足够使用。' },
      { q: '预设和滤镜有什么区别？', a: '预设是一组完整的参数组合，可以完全自定义和微调；滤镜通常是固定效果，可调空间有限。预设更专业、更灵活。' },
      { q: '调色后照片画质会下降吗？', a: '适当的调整不会明显影响画质。但过度提亮阴影或过度锐化可能会导致噪点增加。建议以RAW格式拍摄，后期空间更大。' },
    ],
    relatedArticleIds: [1, 4, 6],
  },
  {
    id: 6,
    slug: 'documentary-photography-mindset',
    title: '人文纪实摄影的思维方式：用镜头讲好一个故事',
    excerpt: '人文纪实摄影不只是按快门，更是一种观察世界的方式。本文探讨纪实摄影师的思维方式，如何发现故事、构建叙事，以及如何在平凡日常中捕捉不平凡的瞬间。',
    category: 'documentary',
    coverImage: 'https://piccraft.github.io/api/search-image?query=Documentary%20photography%20street%20scene%2C%20elderly%20person%20in%20traditional%20market%2C%20warm%20natural%20light%2C%20storytelling%20moment%2C%20cream%20and%20beige%20tones%2C%20editorial%20photojournalism%20style%2C%20authentic%20human%20emotion&width=800&height=450&seq=article-cover-06&orientation=landscape',
    readTime: 11,
    date: '2026-07-28',
    author: '纪实摄影师老周',
    tags: ['人文纪实', '摄影思维', '叙事摄影'],
    content: [
      {
        type: 'h2',
        text: '人文纪实摄影的本质',
      },
      {
        type: 'p',
        text: '人文纪实摄影是用镜头记录人类生活状态的摄影门类。它不同于新闻摄影的时效性，也不同于街头摄影的随机性——人文纪实更强调深度观察和持续关注。一张好的人文纪实照片，应该能让观者透过画面感受到人物的情感、环境的氛围和时代的气息。',
      },
      {
        type: 'h2',
        text: '培养纪实摄影师的观察力',
      },
      {
        type: 'h3',
        text: '从"看"到"观察"',
      },
      {
        type: 'p',
        text: '日常生活中我们都"在看"，但纪实摄影要求我们"观察"。观察意味着注意到光线的方向、人物的表情细节、环境中的对比与呼应。建议每天花15分钟，不带相机，纯粹用眼睛观察一个固定场景——比如地铁站、菜市场、公园——记录你注意到的细节变化。',
      },
      {
        type: 'h3',
        text: '建立"故事感"',
      },
      {
        type: 'p',
        text: '在按下快门前问自己三个问题：这个画面在讲述什么？它代表了什么样的生活状态？10年后回看这张照片，它还有价值吗？当你养成这样的思考习惯，你的照片会从单纯的"好看"升级为"有内容"。',
      },
      {
        type: 'h2',
        text: '实战方法：如何完成一个纪实项目',
      },
      {
        type: 'h3',
        text: '选题：从身边开始',
      },
      {
        type: 'p',
        text: '最好的纪实项目往往就在你身边。你家楼下的早餐摊、每天通勤的地铁线路、父母经营的小店——这些看似平凡的场景在持续关注下都能成为精彩的纪实项目。关键是找到一个你真正感兴趣且有持续接触机会的主题。',
      },
      {
        type: 'h3',
        text: '拍摄：建立信任关系',
      },
      {
        type: 'p',
        text: '与拍摄对象建立信任是人文纪实的核心。不要像"猎人"一样偷偷拍摄然后消失。花时间去了解你的拍摄对象，让他们习惯你的存在。当人们信任你时，他们展现的状态才是真实的、放松的。这种信任关系比任何设备和技术都重要。',
      },
      {
        type: 'h3',
        text: '编辑：筛选与叙事',
      },
      {
        type: 'p',
        text: '纪实摄影的编辑不是挑选"最好看的照片"，而是选择"最能讲述故事的照片"。一个完整的纪实项目通常需要：全景（交代环境）、中景（展现人物关系）、特写（捕捉细节情绪）、以及"决定性瞬间"（项目中最有冲击力的单张）。这四类照片组合在一起，才能构成完整的视觉叙事。',
      },
      {
        type: 'h2',
        text: '伦理与责任',
      },
      {
        type: 'p',
        text: '人文纪实摄影涉及被摄者的生活与隐私，摄影师必须保持尊重和克制。不要为了追求"冲击力"而刻意拍摄被摄者的窘迫状态；照片发表前尽可能征得同意；如实呈现而非刻意扭曲事实。记住：你是在记录，不是在消费他人的生活。',
      },
      {
        type: 'h2',
        text: '总结',
      },
      {
        type: 'p',
        text: '人文纪实摄影的核心不在于设备和技术，而在于你如何看待这个世界。培养敏锐的观察力、建立与被摄者的真诚连接、用影像讲好故事——这才是纪实摄影的真正魅力所在。从今天开始，拿上相机出门，去记录那些你身边正在发生的故事。',
      },
    ],
    faq: [
      { q: '人文纪实和街头摄影有什么区别？', a: '街头摄影更注重瞬间的随机性和趣味性，人文纪实则强调深度、持续性和社会意义。前者是"偶遇"，后者是"深入"。' },
      { q: '拍人文纪实需要专业器材吗？', a: '不需要。很多经典纪实作品都是用普通相机甚至手机拍摄的。纪实摄影更看重内容和故事，设备是次要的。' },
      { q: '如何克服拍摄陌生人的尴尬？', a: '可以先从拍摄背影、剪影开始，逐步过渡到正面。也可以先和对方聊天建立基本关系后再提出拍摄请求。' },
    ],
    relatedArticleIds: [2, 1, 4],
  },
];

export const featuredArticles = [1, 2, 5];

export const testimonials = [
  {
    id: 1,
    name: '摄影小白菜',
    role: '摄影爱好者',
    content: '这个网站的自拍构图教程太实用了！按照黄金分割法练习了一个月，朋友圈的点赞量明显增加了。推荐给所有想提升自拍水平的朋友！',
    rating: 5,
    avatar: 'ri-user-3-line',
  },
  {
    id: 2,
    name: '旅行摄影师阿Ken',
    role: '自由摄影师',
    content: '街头抓拍的那篇文章改变了我的拍摄方式。以前总是害羞不敢拍陌生人，现在按照文章里的技巧练习，已经能自信地在旅途中捕捉真实的人物瞬间了。',
    rating: 5,
    avatar: 'ri-user-3-line',
  },
  {
    id: 3,
    name: '小糖豆',
    role: '美妆博主',
    content: '后期处理的Lightroom调色攻略非常详细，5个预设配方我全都试了一遍，日系清新风简直是我的本命！肤色处理那段让我彻底告别了"假白"时代。',
    rating: 5,
    avatar: 'ri-user-3-line',
  },
  {
    id: 4,
    name: '老王爱拍照',
    role: '退休教师 / 摄影发烧友',
    content: '作为一个拍了十年照片的老爱好者，人文纪实摄影思维方式这篇文章让我重新思考了摄影的意义。纪实不只是记录，更是理解生活的方式。非常受启发。',
    rating: 4,
    avatar: 'ri-user-3-line',
  },
  {
    id: 5,
    name: '数码控小明',
    role: '数码产品评测UP主',
    content: '设备推荐文章非常客观，没有一味推荐贵的。桌面三脚架+蓝牙遥控器的组合推荐太良心了，花很少的钱就解决了大问题。',
    rating: 5,
    avatar: 'ri-user-3-line',
  },
  {
    id: 6,
    name: '旅行中的七七',
    role: '旅行博主',
    content: '脸型与角度那篇文章让我终于知道自己为什么总是不上镜了！原来我是方脸一直用正面直拍，改成45度侧脸后效果立竿见影。感谢这个宝藏网站！',
    rating: 5,
    avatar: 'ri-user-3-line',
  },
];

export const siteInfo = {
  name: '拍得好',
  tagline: '自拍与抓拍技巧分享平台',
  description: '拍得好是一个专注于自拍与人像抓拍技巧的摄影教程平台。我们致力于帮助每一位摄影爱好者拍出自然真实、充满情感的人像作品。',
  email: 'hello@paidehao.com',
  wechat: 'Paidehao_Studio',
  founded: '2024',
  articleCount: 61,
  readerCount: '50,000+',
};